import { ApolloClient, createHttpLink } from '@apollo/client/core'
import { InMemoryCache } from '@apollo/client/cache'
import { split } from '@apollo/client/link/core'
import { setContext } from '@apollo/client/link/context'
import { getMainDefinition } from '@apollo/client/utilities'
import { createApolloProvider } from '@vue/apollo-option'

// NEW imports for graphql-ws
import { createClient } from 'graphql-ws'
import { GraphQLWsLink } from '@apollo/client/link/subscriptions'

const getIdToken = () => {
    const t = localStorage.getItem('AUTH_TOKEN')
    return t ? `Bearer ${t}` : null
}

let endpoint;
let wsendpoint;
if (import.meta.env.MODE === "development") {
  endpoint = import.meta.env.VITE_GRAPHQL_ENDPOINT || "http://localhost:8081";
  wsendpoint = import.meta.env.VITE_GRAPHQL_SOCKET_ENDPOINT || "ws://localhost:8081";
} else {
  const e = window.__env__ || {};
  endpoint = e.UI_GRAPHQL_ENDPOINT || "http://graphql:8081";
  wsendpoint = e.UI_GRAPHQL_SOCKET_ENDPOINT || "ws://graphql:8081";
}
// HTTP link
const httpLink = createHttpLink({
    uri: `${endpoint}/v1/graphql`,
})

// Auth middleware (same)
const authMiddleware = setContext((_, { headers }) => {
    const token = localStorage.getItem("AUTH_TOKEN")
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : "",
        }
    }
})

// NEW WS link using graphql-ws
const wsLink = new GraphQLWsLink(
    createClient({
        url: `${wsendpoint}/v1/graphql`,
        connectionParams: () => ({
            headers: {
                Authorization: getIdToken(),
            },
        }),
        lazy: true,
        retryAttempts: 3,
        shouldRetry: () => true,
    })
)

// Split: subscription → WS, others → HTTP
const splitLink = split(
    ({ query }) => {
        const definition = getMainDefinition(query)
        return (
            definition.kind === "OperationDefinition" &&
            definition.operation === "subscription"
        )
    },
    wsLink,
    httpLink
)

const cache = new InMemoryCache()

export const apolloClient = new ApolloClient({
    link: authMiddleware.concat(splitLink),
    cache,
})

export const apolloProvider = createApolloProvider({
    defaultClient: apolloClient,
})
